import { Component, OnDestroy, OnInit } from '@angular/core';
import { AtlasService } from '../atlas.service';
import { CommonModule } from '@angular/common';
import { ToHtmlPipe } from 'src/app/shared/utilities/to-htmlpipe/to-html.pipe';

@Component({
  selector: 'atlas-embedded-collection',
  templateUrl: './atlas-embedded-collection.component.html',
  styleUrls: ['./atlas-embedded-collection.component.scss'],
  imports: [CommonModule, ToHtmlPipe],
})
export class AtlasEmbeddedCollectionComponent implements OnInit, OnDestroy {
  subscriptions = new Array<any>();
  embeddedCollectionData:any;
  constructor(private atlasPageService: AtlasService) {
    this.subscriptions = [];
  }

  ngOnDestroy(): void {
    if (this.subscriptions && this.subscriptions.length > 0) {
      this.subscriptions.forEach(subscription => {
        subscription.unsubscribe();
      });
    }
  }

  ngOnInit(): void {
    this.atlasPageService.embeddedCollection$.subscribe(data => {
      this.embeddedCollectionData = data?.fields;
    });
  }
}
